// extracted by mini-css-extract-plugin
export var root = "styles-module--root--1wEV-";
export var img = "styles-module--img--18NOR";
export var darkenedEdges = "styles-module--darkenedEdges--2selY";
export var darkened = "styles-module--darkened--1ryif";